<template>
    <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="data-table__head">
            <div class="data-table-sort">
              <p>Pokaż</p>
              <select v-model="perPage" @change="getOrders()">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <p>pozycji</p>
              <select v-model="search.ownOrders" v-if="$parent.grantPermission(['ROLE_COORDINATOR', 'ROLE_EDITOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])" @change="getOrders()">
                <option value="">Wszystkie zlecenia</option>
                <option value="1">Moje zlecenia</option>
              </select>
              <label class="checkbox"><input type="checkbox" v-model="search.inProgress" @change="getOrders()"/><span class="checkmark"></span> W trakcie</label>
            </div>
            <div class="button-group" v-if="$parent.grantPermission(['ROLE_COORDINATOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_CENTRAL', 'ROLE_LOCAL'])">
              <!--<span class="button-module-table" @click="uploadPopup = true">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 504 504" style="enable-background:new 0 0 504 504;" xml:space="preserve" width="512px" height="512px">
                  <g>
                    <path d="M311.3,108.74c-15.304,0-27.752,12.444-27.752,27.752c0.004,15.3,12.452,27.744,27.752,27.744s27.752-12.44,27.752-27.744    C339.052,121.188,326.604,108.74,311.3,108.74z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#E02020"/>
                  </g>
                  <g>
                    <path d="M252.164,286.1c-49.992,0-90.508,40.52-90.508,90.5c0,49.984,40.516,90.508,90.508,90.508s90.512-40.524,90.512-90.508    C342.676,326.62,302.156,286.1,252.164,286.1z M303.148,387.328h-39.336v40.344c0,6.476-5.336,11.744-11.812,11.744    s-11.812-5.264-11.812-11.744v-40.344h-39.172c-6.476,0-11.748-5.336-11.748-11.812s5.268-11.812,11.748-11.812h39.172v-38.168    c0-6.472,5.336-11.744,11.812-11.744s11.812,5.268,11.812,11.744v38.168h39.336c6.476,0,11.748,5.336,11.748,11.812    S309.624,387.328,303.148,387.328z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#E02020"/>
                  </g>
                  <g>
                    <path d="M484.356,36.892H19.976C9.12,36.892,0,46.56,0,57.416v299.496c0,10.86,9.12,18.6,19.976,18.6h118.056    c0-63,51.2-114.124,114.132-114.124c62.936,0,114.136,51.124,114.136,114.124h118.056c10.856,0,19.644-7.744,19.644-18.6V57.416    C504,46.56,495.212,36.892,484.356,36.892z M391.5,172.552l-74.456,74.472L203.712,133.708c-1.54-1.54-4.024-1.54-5.564,0    l-71.884,71.88l-32.816-32.812c-1.536-1.54-4.172-1.54-5.708,0l-52.304,52.16V72.328H468.56v171.748l-71.5-71.524    C395.52,171.012,393.04,171.012,391.5,172.552z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#E02020"/>
                  </g>
                </svg>
                <p>Prześlij grafiki</p>
              </span>-->
              <span class="button-module-table" @click="$router.push('/order/add');">
                <svg xmlns="http://www.w3.org/2000/svg" height="512px" viewBox="0 0 448 448" width="512px">
                  <g>
                    <path d="m408 184h-136c-4.417969 0-8-3.582031-8-8v-136c0-22.089844-17.910156-40-40-40s-40 17.910156-40 40v136c0 4.417969-3.582031 8-8 8h-136c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40h136c4.417969 0 8 3.582031 8 8v136c0 22.089844 17.910156 40 40 40s40-17.910156 40-40v-136c0-4.417969 3.582031-8 8-8h136c22.089844 0 40-17.910156 40-40s-17.910156-40-40-40zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  </g>
                </svg>
                <p>Nowe zlecenie</p>
              </span>
            </div>
        </div>
        <b-container fluid>
            <!-- Main table element -->
          <div class="table--wrapper">
            <b-table
              class="table--tight app-table orders-table"
              show-empty
              stacked="md"
              striped
              :busy="isBusy"
              :items="items"
              :fields="fields"
              :paginated="false"
              :backend-sorting="true"
              @filtered="onFiltered"
              :tbody-tr-class="rowClass"
              @row-dblclicked="prepareToCopyOrder" 
              hover>

              <template slot="empty">
                <p class="empty-message">Brak rekordów</p>
              </template>

              <template slot="HEAD_status" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'status'}" @click="sortDir('status')">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'status'"></div>
                  </label>
                  <select class="form-control form-control-lg" v-model="search.status" @input="searching()">
                    <option value=""></option>
                    <option v-for="status in statuses" :key="status.id" :value="status.id">{{status.name}}</option>
                  </select>
                </div>
              </template>

              <template slot="HEAD_order_number" slot-scope="data" class="test" >
                <div class="form-group">
                  <label :class="{'active' : sortField == 'number'}" @click="sortDir('number')" >
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'number'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.number" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_name" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'name'}" @click="sortDir('name')" style="white-space: nowrap;">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'name'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.name" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_type" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'type'}" @click="sortDir('type')" >
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'type'"></div>
                  </label>
                  <select class="form-control form-control-lg" v-model="search.type" @input="searching()">
                    <option value=""></option>
                    <option v-for="type in types" :key="type.id" :value="type.id">{{type.name}}</option>
                  </select>
                </div>
              </template>

              <template slot="HEAD_edition" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'edition'}" @click="sortDir('edition')" style="white-space: nowrap;">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'edition'"></div>
                  </label>
                  <select class="form-control form-control-lg" v-model="search.edition" @input="searching()">
                    <option value=""></option>
                    <option v-for="edition in editions" :key="edition.id" :value="edition.id">{{edition.name}}</option>
                  </select>
                </div>
              </template>

              <template slot="HEAD_end_of_the_stage" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'endOfStage'}" @click="sortDir('endOfStage')">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'endOfStage'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.endOfStage" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_printing_date" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'orderForPrinting'}" @click="sortDir('orderForPrinting')">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'orderForPrinting'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.orderForPrinting" @input="searching()" />
                </div>
              </template>

              <template slot="HEAD_guntenberg_coordinator" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'gutenbergCoordinator'}" @click="sortDir('gutenbergCoordinator')">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'gutenbergCoordinator'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.gutenbergCoordinator" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_mediamarkt_coordinator" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'mediaMarktCoordinator'}" @click="sortDir('mediaMarktCoordinator')">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'mediaMarktCoordinator'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.mediaMarktCoordinator" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_offer_from" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'offerFrom'}" @click="sortDir('offerFrom')" style="white-space: nowrap;">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'offerFrom'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.offerFrom" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_offer_to" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'offerTo'}" @click="sortDir('offerTo')" style="white-space: nowrap;">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'offerTo'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.offerTo" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_updated" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'editedLastTime'}" @click="sortDir('editedLastTime')" style="white-space: nowrap;">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'editedLastTime'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.editedLastTime" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_clear" slot-scope="data">
                <div class="form-group">
                  <div class="button-group">
                    <span class="button-normal button-normal--clear" @click="clearSearch()"><img src="../assets/symbols/iks.svg" /></span>
                  </div>
                </div>
              </template>

              <template slot="status" slot-scope="data">
                <b-badge :class="{
                  'badge-red' : data.item.oldestPageStatus.code == 'mm_build' || data.item.oldestPageStatus.code == 'first_correct_mm' || data.item.oldestPageStatus.code == 'second_correct_mm' || data.item.oldestPageStatus.code == 'additional_correct_mm',
                  'badge-yellow' : data.item.oldestPageStatus.code == 'to_accept',
                  'badge-navy' : data.item.oldestPageStatus.code == 'first_gun_build' || data.item.oldestPageStatus.code == 'second_gun_build' || data.item.oldestPageStatus.code == 'first_correct_gun' || data.item.oldestPageStatus.code == 'additional_correct_gun',
                  'badge-green' : data.item.oldestPageStatus.code == 'accept',
                  'badge-light-grey' : data.item.oldestPageStatus.code == 'archived',
                  'badge-dark-grey' : data.item.oldestPageStatus.code == 'cancelled',
                  'badge-waiting' : data.item.oldestPageStatus.code == 'waiting',
                  }">{{ data.item.oldestPageStatus.name }}</b-badge>
              </template>
              
              <template slot="order_number" slot-scope="data">
                <div class="edit-order-box">
                  <router-link v-if="$parent.grantPermission(['ROLE_COORDINATOR', 'ROLE_EDITOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_LOCAL', 'ROLE_CENTRAL'])" class="select-link" :to="{ name: 'OrderEdit', params: { id: data.item.id}}">{{ data.item.number }}</router-link>
                  <span class="edit-icon"><img src="../assets/symbols/icon-edit.svg"/></span>
                </div>
              </template>
              
              <template slot="name" slot-scope="data">
                <!--<a :href="`#${data.value.replace(/[^a-z]+/i,'-').toLowerCase()}`">{{ data.value }}</a>-->
                <router-link v-if="$parent.grantPermission(['ROLE_COORDINATOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_EDITOR', 'ROLE_CENTRAL', 'ROLE_LOCAL'])" class="select-link order-name-link" :to="{ name: 'OrderAccept', params: { id: data.item.id}}">{{ data.value }}</router-link>
              </template>

              <template slot="type" slot-scope="data">
                {{ data.item.type.name }}
              </template>

              <template slot="edition" slot-scope="data">
                {{ data.item.edition.name }}
              </template>

              <template slot="end_of_the_stage" slot-scope="data">
                {{ data.item.endOfStage }}
              </template>

              <template slot="printing_date" slot-scope="data">
                {{ data.item.orderForPrinting }}
              </template>

              <template slot="guntenberg_coordinator" slot-scope="data">
                {{ !data.item.gutenbergCoordinator ? '' : data.item.gutenbergCoordinator.name }} {{ !data.item.gutenbergCoordinator ? '' : data.item.gutenbergCoordinator.surname }}
              </template>

              <template slot="mediamarkt_coordinator" slot-scope="data">
                {{ !data.item.mediaMarktCoordinator ? '' : data.item.mediaMarktCoordinator.name}} {{ !data.item.mediaMarktCoordinator ? '' : data.item.mediaMarktCoordinator.surname }}
              </template>
              
              <template slot="offer_from" slot-scope="data">
                {{ data.item.offerFrom.split(' ')[0] }}
              </template>

              <template slot="offer_to" slot-scope="data">
                {{ data.item.offerTo.split(' ')[0] }}
              </template>

              <template slot="updated" slot-scope="data">
                {{ data.item.editedLastTime }}
              </template>


            </b-table>
          </div>
        </b-container>
        <b-row>
            <b-col class="my-1">
              <b-pagination
                v-if="!items.length == 0"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="float-right"
                @change="pageChange">
              </b-pagination>
            </b-col>
          </b-row>
      </div>
      <copyPopup v-if="copyPopup" :orderId="orderToCopy" :orderNumber="numberToCopy" :orderName="nameToCopy" @canceled="cancelCopy()"/>
      <filePopup v-if="uploadPopup" @confirm="uploadPopup = false" @cancel="uploadPopup = false"/>
    </div>

</template>

<script>

import debounce from "lodash.debounce";
import copyPopup from '@/components/blocks/dashboard/copyPopup.vue';
import filePopup from '@/components/blocks/files/filePopup.vue';

export default {

  name: 'Dashboard',
  components:{

    copyPopup,
    filePopup

  },
  data () {

    return {

      title: 'Zlecenia',

      isBusy: false,
      fields: [

          {
            key: 'status', 
            label: 'Status' 
          },
          {
            key: 'order_number', 
            label: 'Nr zlecenia' 
          },
          {
            key: 'name', 
            label: 'Nazwa zlecenia' 
          },
          {
            key: 'type', 
            label: 'Rodzaj zlecenia' 
          },
          {
            key: 'edition', 
            label: 'Wydanie' 
          },
          {
            key: 'end_of_the_stage', 
            label: 'Koniec etapu' 
          },
          {
            key: 'printing_date', 
            label: 'Termin druku' 
          },
          {
            key: 'guntenberg_coordinator', 
            label: 'Koordynator Gutenberg' 
          },
          {
            key: 'mediamarkt_coordinator', 
            label: 'Koordynator MediaMarkt' 
          },
          {
            key: 'offer_from', 
            label: 'Oferta od' 
          },
          {
            key: 'offer_to', 
            label: 'Oferta do' 
          },
          {
            key: 'updated', 
            label: 'Zaktualizowano' 
          },
          {
            key: 'clear', 
            label: '' 
          },

        ],

      items: [],

      orderToCopy: 0,
      copyPopup: false,
      numberToCopy :'',
      nameToCopy :'',

      uploadPopup: false,

      /* Selects options */
      
      statuses:[],
      types:[],
      editions:[],

      /* Search object */

      search:{
        status: '',
        number: '',
        name: '',
        type: '',
        edition: '',
        endOfStage: '',
        orderForPrinting: '',
        gutenbergCoordinator: '',
        mediaMarktCoordinator: '',
        offerFrom: '',
        offerTo: '',
        editedLastTime: '',
        ownOrders: '',
        inProgress: ''
      },

      /* Table sorting */

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      offset: 0,
      sort: false,
      sortField: 'editedLastTime',
      sortDirection: 'DESC',

    }

  },
  watch: {

    'search.ownOrders': function(newVal, oldVal){
      this.storeDataInStorage('ownSearch', this.search.ownOrders);
      this.setCookie('ownSearch', this.search.ownOrders, 360);
    }

  },
  methods:{

    sortDir(field){
      
      if(field != this.sortField && field === 'status'){

        this.sortField = field; 
        this.sort = false;
        this.sortDirection = 'ASC',

        this.searching();

        return;

      }
      
      if(field != this.sortField){

        this.sortField = field; 
        this.sort = false;
        this.sortDirection = 'DESC',

        this.searching();

        return;

      }
      
      this.sortDirection == 'DESC' ? this.sortDirection = 'ASC' : this.sortDirection = 'DESC';
      this.sortField = field; 
      this.sort = !this.sort;
      this.searching();

    },

    getFormData(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('order/form/data', {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.statuses = response.data.status;
          this.types = response.data.type;
          this.editions = response.data.edition;

        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    splitValue(company){

      if(company == 'mm'){

        let data = this.mediaMarktCoordinator;

          if (/\s/.test(data)) {

            data = data.split(' ');
            
            this.search.mediaMarktCoordinatorName = data[0];
            this.search.mediaMarktCoordinatorSurname = data[1];

          }else{

            this.search.mediaMarktCoordinatorName = data;
            this.search.mediaMarktCoordinatorSurname = data;

          }

      }

      if(company == 'gut'){

        let data = this.gutenbergCoordinator;

          if (/\s/.test(data)) {

            data = data.split(' ');
            this.search.gutenbergCoordinatorName = data[0];
            this.search.gutenbergCoordinatorSurname = data[1];

          }else{

            this.search.gutenbergCoordinatorName = data;
            this.search.gutenbergCoordinatorSurname = data;

          }

      }

      this.searching();

    },

    getOrders(){

      this.isBusy = true;

      const token = localStorage.getItem('auth_token');

      let request = {
        'limit' : this.perPage,
        'offset' : this.offset,
        'sort' : this.sortDirection,
        'sort_field' : this.sortField,
      }

      const entries = Object.entries(this.search);

      for (const [key, value] of entries) {
        
        if(value != ''){
          request[key] = value;
        }

      }

      this.$http.get('order/orders', {
        params:request,
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.items = response.data.list;
          this.totalRows = response.data.total;
          this.isBusy = false;

        })
        .catch(error =>{
          
          if(error.response.status === 401) {
            
            this.$router.push('/');

          }
          
          if(error.response.status === 400){

            this.items = [];
            this.totalRows = 0;
            this.isBusy = false;
            
          }else{

            console.error(error.response);
            this.loading = false;

          }

        })

    },

    searching: debounce(function(){

      this.currentPage = 1;
      this.offset = 0;
      this.getOrders();

    }, 500),

    pageChange (page) {

      this.currentPage = page
      this.offset = ((this.currentPage - 1) * this.perPage);
      this.getOrders();
      
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    clearSearch(){

        this.search.status =  '';
        this.search.number =  '';
        this.search.name =  '';
        this.search.type =  '';
        this.search.edition =  '';
        this.search.endOfStage =  '';
        this.search.orderForPrinting =  '';
        this.search.gutenbergCoordinator =  '';
        this.search.mediaMarktCoordinator = '';
        this.search.offerFrom =  '';
        this.search.offerTo =  '';
        this.search.editedLastTime =  '';
        this.search.field = '';
        this.sortField = 'editedLastTime'; 
        this.sort = false;
        this.sortDirection = 'DESC',

        this.getOrders();

    },

    rowClass(item, type) {
      if (!item) return;
      if ( item.oldestPageStatus == 'Archiwizacja' || item.oldestPageStatus == 'Anulowane' ) {
        return 'row--archive'
      }
    },

    prepareToCopyOrder(row, index, element){

      this.orderToCopy = row.id;
      this.numberToCopy = row.number;
      this.nameToCopy = row.name;
      this.copyPopup = true;

      let findRow = element.target.parentElement.querySelector('td');
      let tr;

      if(findRow){

        tr = element.target.parentElement;

      }else if(element.target.classList.contains('badge')){

        tr = element.target.parentElement.parentElement.parentElement;

      }else{

        tr = element.target.parentElement.parentElement

      }

      if(tr.classList.contains('selected-row')){

        tr.classList.remove('selected-row');
        return;

      }

      let rows = document.querySelectorAll('.selected-row');

      rows.forEach(row => {
        row.classList.remove('selected-row');
      });

      tr.classList.add('selected-row');

    },

    cancelCopy(){

      let rows = document.querySelectorAll('.selected-row');
      this.orderToCopy = 0;
      this.numberToCopy = 0;
      this.nameToCopy = '';
      this.copyPopup = false;

      rows.forEach(row => {
        row.classList.remove('selected-row');
      });

    }

  },
  mounted(){

    if (this.getCookie('ownSearch')) this.search.ownOrders = this.getCookie('ownSearch');
    this.getFormData();
    this.getOrders();
    this.totalRows = this.items.length

  }
};
</script>

<style lang="scss" >

.selected-row td{
  position: relative !important;
  box-sizing: border-box !important;
  border-top:2px black solid !important;
  border-bottom:2px black solid !important;

  &:first-of-type{
    border-left:2px black solid !important;
  }

  &:last-of-type{
    border-right:2px black solid !important;
  }
}

.edit-order-box{
  display:flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  position: relative;

  & span{
    width:15%;
    visibility: hidden;
    position: absolute;
    right:0;

    & img{
      display:block;
      width:100%;
    }
  }

  .select-link:hover ~ span{
    visibility: visible;
  }

}

.order-name-link{
  text-decoration: none !important;

  &:hover{
    text-decoration: underline !important;
  }
}

</style>
